import { Grid } from "@mui/material";
import { Typography } from "@platform/design-system";

import { paletteVar } from "../../../../theme/palette-var";

import type { FieldComponent } from "../types";

const SectionTitleComponent: FieldComponent<never> = ({ field }) => (
  <Grid
    container
    sx={{
      backgroundColor: paletteVar("surfaces-neutral", "#f2f2f2"),
      marginTop: (theme) => theme.spacing(3),
      marginBottom: (theme) => theme.spacing(3),
      padding: (theme) => theme.spacing(1.5, 2),
      display: "flex",
      justifyContent: field.children ? "space-between" : "flex-start",
      alignItems: "center",
      ...field.sx,
    }}
    className={field.className}
    style={field.style}
  >
    <Typography variant={field.variant || "header-medium"} component="div">
      <strong>{field.label}</strong>
    </Typography>
    {field.children}
  </Grid>
);

export default SectionTitleComponent;
